@if (activeLanguage === 'en') {
  <div>
    <div class="compressor1" style="font-size:24px"><b>Don’t get burned by inferior parts.</b></div><br>
    <div class="compressor2" style="line-height:52px">Only genuine Bendix® remanufactured BA-921® DD13/15/16 compressors
    are:</div>
    <ul class="compressor3" style="padding-left: 50px">
      <li>Remanufactured to OE clearances and specifications</li>
      <li>Tested to the highest standard using proprietary test specifications</li>
      <li>Expertly remanufactured to outlast any competitor</li>
    </ul>Genuine Bendix Remanufactured compressors have 35% less oil passing* than the competition. Higher levels of
    oil
    passing may cause downstream contamination and potential component failure.
  </div>
  <div> <a [href]='latestDocUrl$ |async' target="_blank">*See BW8223, Genuine® Bendix® BA-921® DD13/15/16 Compressor
  Competitive Comparison brochure</a>
</div>
}

@if (activeLanguage === 'fr_CA') {
  <div>Ne vous faites pas avoir par des pièces de qualité inférieure.
    Seuls les compresseurs BA-921® DD13/15/16 remanufacturés d'origine Bendix® sont :<ul style="padding-left: 50px">
    <li>Remise à neuf selon les tolérances et les spécifications de l'équipement d'origine</li>
    <li>Testé selon les normes les plus strictes à l'aide de spécifications d'essai exclusives</li>
    <li>Remis à neuf par des experts pour durer plus longtemps que n'importe quel concurrent</li>
  </ul>Les compresseurs Bendix Remanufacturés d'origine laissent passer 35 % d'huile en moins* que les
  compresseurs concurrents. Des niveaux plus élevés de passage d'huile peuvent entraîner une contamination en aval
et une défaillance potentielle des composants.</div>
<div> <a [href]='latestDocUrl$ |async' target=" _blank">
  <div></div>
  <div>*(Voir BW8223, Genuine® Bendix® BA-921® DD13/15/16 compresseurs brochure de comparaison concurrentielle)
  </div>
</a>
</div>
}

@if (activeLanguage === 'es_MX') {
  <div>
    Sólo los compresores originales Bendix® remanufacturados BA-921® DD13/15/16:
    <ul style="padding-left: 50px">
      <li>Remanufacturado según las especificaciones y holguras del equipo original</li>
      <li>Probado al más alto nivel utilizando especificaciones de prueba propias</li>
      <li>E Remanufacturado por expertos para durar más que cualquier competidor</li>
    </ul>Los compresores originales Bendix Remanufactured tienen un 35% menos de paso de aceite* que los de la
    competencia. Los niveles más altos de paso de aceite pueden causar contaminación aguas abajo y posibles fallos
    de
    los componentes.
  </div>
  <div><a [href]='latestDocUrl$ |async' target="_blank">
    <div></div>*(Ver BW8223, folleto comparativo de compresores Genuine® Bendix® BA-921® DD13/15/16)
  </a>
</div>
}
